require('./portfolioListErrorState.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @actions
const customWalletPortfoliosActions = require('customWallets/actions/brokerCustomWalletGetPortfoliosList');

class portfolioListErrorState extends React.Component {

    render() {
        return (
            <div className="portfolio-list-error-state">
                <div className="portfolio-list-error-state__msj">
                    {formatText('broker-informationViewsNotAvailable')}
                </div>
                <span
                    className="ok-link portfolio-list-error-state__link"
                    onClick={() => this.props.getPortfolioList()}
                >
                    {formatText('broker-informationViewsRetry')}
                </span>
            </div>
        );
    }

}

portfolioListErrorState.propTypes = {
    getPortfolioList: PropTypes.func.isRequired,
};

module.exports.constructor = portfolioListErrorState;
module.exports.portfolioListErrorState = connect(
    null,
    {
        getPortfolioList: customWalletPortfoliosActions.getPortfolioList,
    }
)(portfolioListErrorState);
